import { ForwardedRef, forwardRef, RefObject } from "react";
import {
  ModalHeader,
  ModalCloseButton,
  ModalFooter,
  ModalBody,
  VStack
} from "@gluestack-ui/themed";

import { Icon } from "@repo/core/components/core/Icon";

import { Modal } from "../../Modal";
import { IModalRefProps } from "../../Modal/types";
import { ActionSheet } from "../../Actionsheet";
import { useConfirmStoreModalController } from "./controller";
import { ConfirmStoreModalBody } from "./components/ConfirmStoreModalBody";
import { ConfirmStoreModalFooter } from "./components/ConfirmStoreModalFooter";
import { ConfirmStoreModalProps } from "@repo/core/components/layout/ModalTemplate/ConfirmStoreModal/types";

export const ConfirmStoreModal = forwardRef(function Drawer(
  { onSelectCancel }: ConfirmStoreModalProps,
  ref: ForwardedRef<IModalRefProps>
) {
  const {
    isMobile,
    selectedStore,
    handleOnChangeDontShowAgain,
    handleOnSelectConfirm,
    handleOnSelectCancel
  } = useConfirmStoreModalController({
    onSelectCancel,
    ref: ref as RefObject<IModalRefProps>
  });

  const renderMobile = () => {
    return (
      <ActionSheet ref={ref}>
        <VStack w="$full" p="$2" gap="$4">
          <ConfirmStoreModalBody
            selectedStore={selectedStore}
            onChangeDontShowAgain={handleOnChangeDontShowAgain}
          />
          <ConfirmStoreModalFooter
            onSelectConfirm={handleOnSelectConfirm}
            onSelectCancel={handleOnSelectCancel}
          />
        </VStack>
      </ActionSheet>
    );
  };

  const renderDesktop = () => {
    return (
      <Modal ref={ref}>
        <ModalHeader justifyContent="flex-end">
          <ModalCloseButton>
            <Icon name="times" size="xs" />
          </ModalCloseButton>
        </ModalHeader>
        <ModalBody>
          <ConfirmStoreModalBody
            selectedStore={selectedStore}
            onChangeDontShowAgain={handleOnChangeDontShowAgain}
          />
        </ModalBody>
        <ModalFooter alignItems="center">
          <ConfirmStoreModalFooter
            onSelectConfirm={handleOnSelectConfirm}
            onSelectCancel={handleOnSelectCancel}
          />
        </ModalFooter>
      </Modal>
    );
  };

  return isMobile ? renderMobile() : renderDesktop();
});
